import React from 'react';
import { connect } from 'react-redux';
import { MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import CheckIcon from '@mui/icons-material/CheckRounded';
import { saveFreezeVideoBackground } from '../../../../../utilities/storageUtilities';

const styles = theme => ({
    previewSettingMenuItemIcon: {
        minWidth: theme.spacing(5)
    },
    previewSettingMenuItemText: {
        textAlign: 'right'
    }
});

const FreezeVideoBackgroundSelect = (props) => {
    const { classes, freezeVideoBackground, setProperty } = props;

    const onAnimateClick = ()  => {
        setProperty('freezeVideoBackground', false);
        saveFreezeVideoBackground(false);
    };

    const onPauseClick = ()  => {
        setProperty('freezeVideoBackground', true);
        saveFreezeVideoBackground(true);
    };

    return (
        <>
            <MenuItem 
                onClick={onAnimateClick}
                selected={!freezeVideoBackground}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: !freezeVideoBackground ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    ANIMATE
                </ListItemText>
            </MenuItem>
            <MenuItem 
                onClick={onPauseClick}
                selected={freezeVideoBackground}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: freezeVideoBackground ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    PAUSE
                </ListItemText>
            </MenuItem>
        </>
    );
};

const mapStateToProps = (state) => {
    const { freezeVideoBackground } = state.create;
    return { freezeVideoBackground };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    return { setProperty }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(FreezeVideoBackgroundSelect, styles));